import { useCallback, type FunctionComponent } from 'react';

import { useSharedStateSelector } from '@trello/shared-state';
import { workspaceState } from '@trello/workspace-state';

import { useHasReverseTrialExperience } from 'app/src/components/FreeTrial';
import { useWorkspaceHasRedeemedReferralPromotion } from 'app/src/components/PremiumReferrerPopup/useWorkspaceHasRedeemedReferralPromotion';
import { PremiumTrialModalOverlay } from './PremiumTrialModalOverlay';

const PREMIUM_TRIAL_MODAL_MESSAGE_DISMISSED_KEY_PREFIX =
  'premium-trial-modal-message-dismissed-for-ws';

const PREMIUM_REFERRAL_REWARD_MODAL_MESSAGE_DISMISSED_KEY_PREFIX =
  'premium-referral-reward-modal-message-dismissed-for-ws';

export const PremiumTrialModalOverlays: FunctionComponent = () => {
  const hasReverseTrialExperience = useHasReverseTrialExperience();

  const workspaceId =
    useSharedStateSelector(
      workspaceState,
      useCallback((state) => state?.workspaceId, []),
    ) || '';

  const hasPremiumReferralReward =
    useWorkspaceHasRedeemedReferralPromotion(workspaceId);

  if (hasPremiumReferralReward) {
    return (
      <PremiumTrialModalOverlay
        messageDismissedKeyPrefix={
          PREMIUM_REFERRAL_REWARD_MODAL_MESSAGE_DISMISSED_KEY_PREFIX
        }
        analyticsAttributes={{
          acceptButtonName: 'acceptPremiumReferralRewardModalButton',
          screenName: 'announcePremiumReferralRewardModalScreen',
        }}
      />
    );
  } else if (hasReverseTrialExperience) {
    return (
      <PremiumTrialModalOverlay
        messageDismissedKeyPrefix={
          PREMIUM_TRIAL_MODAL_MESSAGE_DISMISSED_KEY_PREFIX
        }
        analyticsAttributes={{
          acceptButtonName: 'acceptReverseTrialModalButton',
          extendTrialButtonName: 'extendReverseTrialModalButton',
          screenName: 'announceReverseTrialModalScreen',
        }}
      />
    );
  }

  return null;
};
